import { ThemeColors } from '../../../'

export interface CloseButtonColors {
  Primary: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
    Icon: ThemeColors
  }
  AlertWindow: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
    Icon: ThemeColors
  }
}

export const closeButtonColors: CloseButtonColors = {
  Primary: {
    Background: {
      Default: {
        default: 'transparent',
      },
      Hover: {
        default: 'bg.emphasized',
      },
      Active: {
        default: 'bg.muted',
      },
    },
    Icon: {
      default: 'fg.default',
    },
  },
  AlertWindow: {
    Background: {
      Default: {
        default: 'transparent',
      },
      Hover: {
        default: 'overlay.light',
      },
      Active: {
        default: 'overlay.medium',
      },
    },
    Icon: {
      default: 'brand.contrast',
    },
  },
}
